import { FormSectionHeader, Loader } from "@/components";
import { Card, CardContent } from "@/components/ui";
import { CircleDollarSign } from "lucide-react";
import useFinancialOverview from "./useFinancialOverview";

const FinancialOverview = () => {
  const { currentFinanceYear, overviewRows, isLoading } = useFinancialOverview();

  return (
    <Card className="bg-primary text-white shadow-none">
      <CardContent>
        <FormSectionHeader className="text-[18px] font-[500] flex flex-row items-center gap-2 text-white">
          Financial Overview ({currentFinanceYear})
          <CircleDollarSign className="h-7 w-7" />
        </FormSectionHeader>
        {isLoading ? (
          <Loader variant="secondary" containerClassName="h-fit" />
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-[14px] border-collapse">
              <thead>
                <tr className="border-b border-white/30">
                  <th className="py-2 pr-3 text-left font-[500]"></th>
                  <th className="py-2 px-2 text-right font-[600]">Budget</th>
                  <th className="py-2 px-2 text-right font-[600]">Actual</th>
                  <th className="py-2 pl-2 text-right font-[600]">Variance</th>
                </tr>
              </thead>
              <tbody>
                {overviewRows.map((row) => (
                  <tr key={row.label} className="border-b border-white/20 last:border-b-0">
                    <td className="py-2 pr-3 font-[500]">{row.label}</td>
                    <td className="py-2 px-2 text-right font-[700]">{row.budget}</td>
                    <td className="py-2 px-2 text-right font-[700]">{row.actual}</td>
                    <td className="py-2 pl-2 text-right font-[700]">{row.variance}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  )
}

export default FinancialOverview;
